import React, {Component} from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import LockIcon from '@material-ui/icons/Lock'
import ConfirmationDialog from 'components/ConfirmationDialog'
import Typography from '@material-ui/core/Typography'
import { authorizedLink } from 'utils'
import {Authorization} from 'utils'
import { withRouter } from 'react-router-dom'

export class Downloads extends Component {
  static propTypes = {
    dealSheet: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      showKycAlert: false,
    }
  }

  handleDownload = (event) => {
    if(!Authorization.approved && !Authorization.admin) {
      event.preventDefault()
      event.stopPropagation()
      this.setState({showKycAlert: true})
      return false
    }
  }

  handleConfirmKycAlert = () => {
    this.setState({showKycAlert: false})
    if(Authorization.issuerStatus === 'not_applied') {
      this.props.history.push(`/investor/${Authorization.user.id}/edit`)
    } else if(Authorization.investorStatus === 'not_applied') {
      this.props.history.push(`/issuer/${Authorization.user.id}/edit`)
    } else {
      // nothing
    }
  }

  renderDownloadLink = (download) => {
    if (download.documentUrl) {
      return <a href={download.documentUrl} onClick={this.handleDownload} target='_blank' rel="noopener noreferrer"><DownloadIcon />Download</a>
    } else {
      return <a href={authorizedLink(download.attachmentUrl)} onClick={this.handleDownload}><DownloadIcon />Download</a>
    }
  }

  render = () =>
    <div className={this.props.className}>
      <div className={styles.flexContainer}>
        {this.props.dealSheet.downloads && this.props.dealSheet.downloads.map(download =>
          <div className={styles.flexCell} key={download.id}>
            <h3 className={styles.heading}>{download.name} {download.isPrivate && <LockIcon/>}</h3>
            <div className={styles.detail}>
              <p>{download.description}</p>
              {this.renderDownloadLink(download)}
            </div>
          </div>
        )}
      </div>
      <ConfirmationDialog open={this.state.showKycAlert}
          title='KYC Required'
          onClose={this.handleConfirmKycAlert}
          onCancel={() => this.setState({showKycAlert: false})}
          onConfirm={this.handleConfirmKycAlert}
          canCancel canConfirm cancelLabel='Back' confirmLabel='KYC'>
        <Typography variant="body1">
          Please complete KYC to download deal documents.
        </Typography>
      </ConfirmationDialog>
    </div>
}

const styles = StyleSheet({
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  flexCell: {
    flex: '1',
    minWidth: 400,
    maxWidth: '50%',
    paddingRight: 75,
    boxSizing: 'border-box',
    marginBottom: 50,
    '@media(max-width: 875px)': {
      maxWidth: '100%',
    },
    '@media(max-width: 600px)': {
      paddingRight: 0,
      minWidth: 301,
    }
  },
  heading: {
    fontSize: '16px',
    paddingBottom: 15,
    fontWeight: 'bold',
    margin: 0,
    '& svg': {
      verticalAlign: 'sub'
    }
  },
  detail: {
    fontSize: '13px',
    lineHeight: '20px',
    '& p': {
      marginTop: 0,
    },
    '& a': {
      color: '#6AAEAA',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      '& svg': {
        verticalAlign: 'middle',
        marginRight: 10,
      }
    }
  },
})

export default withRouter(Downloads)

